import { heroFeature, heroSide } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="top" className="relative w-full">
      <div className="relative min-h-[640px] md:min-h-[760px] w-full overflow-hidden flex flex-col">
        <div className="absolute inset-0 w-full h-full">
          <img
            src={heroFeature.image}
            alt="18爆料网事件深扒主视觉：深夜录音与时间线封面"
            title="18爆料网事件深扒 · 主视觉封面"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/75" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-transparent to-black/30" />
        </div>

        <div className="relative z-10 flex-1 flex items-end">
          <div className="mx-auto w-full max-w-[1360px] px-4 md:px-6 lg:px-10 pt-32 pb-10 md:pb-14">
            <div className="max-w-3xl bl-fade-up">
              <div className="flex flex-wrap items-center gap-2.5">
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                  <span className="w-1.5 h-1.5 rounded-full bg-background-50 bl-pulse-dot" />
                  {heroFeature.tag}
                </span>
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50/15 text-background-50 text-xs backdrop-blur border border-background-50/25">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-fire-line text-accent-400 text-sm" />
                  </span>
                  今日热榜第 1 位
                </span>
              </div>

              <h1 className="mt-6 font-heading font-black text-background-50 leading-[1.15] text-3xl md:text-5xl lg:text-[3.4rem]">
                {heroFeature.title}
              </h1>

              <p className="mt-5 text-background-100/90 text-sm md:text-lg leading-relaxed max-w-2xl">
                {heroFeature.summary}
              </p>

              <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs md:text-sm text-background-200">
                <span className="flex items-center gap-1.5">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-user-3-line text-[15px]" />
                  </span>
                  {heroFeature.author}
                </span>
                <span className="flex items-center gap-1.5">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-calendar-line text-[15px]" />
                  </span>
                  {heroFeature.date}
                </span>
                <span className="flex items-center gap-1.5">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-time-line text-[15px]" />
                  </span>
                  阅读 {heroFeature.readTime}
                </span>
                <span className="flex items-center gap-1.5">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-eye-line text-[15px]" />
                  </span>
                  {heroFeature.views}
                </span>
              </div>

              <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                <a
                  href="#dig"
                  className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-book-open-line text-lg" />
                  </span>
                  读完整深扒
                </a>
                <a
                  href="#archive"
                  className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-background-50/10 text-background-50 text-sm md:text-base font-medium border border-background-50/30 backdrop-blur hover:bg-background-50/20 transition-colors whitespace-nowrap"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-folder-shield-2-line text-lg" />
                  </span>
                  查看实锤档案
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="relative z-10 mx-auto w-full max-w-[1360px] px-4 md:px-6 lg:px-10 pb-10 md:pb-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {heroSide.map((item) => (
              <a
                key={item.id}
                href="#dig"
                className="group flex items-stretch gap-4 p-3 rounded-lg bg-background-50/10 border border-background-50/20 backdrop-blur hover:bg-background-50/20 transition-colors"
              >
                <div className="w-24 h-20 md:w-28 md:h-[76px] shrink-0 rounded-md overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={`${item.title} · 18爆料网`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-col justify-center min-w-0">
                  <span className="text-[11px] font-medium text-accent-400">{item.tag}</span>
                  <h3 className="mt-1 text-sm md:text-base font-medium text-background-50 leading-snug line-clamp-2">
                    {item.title}
                  </h3>
                  <span className="mt-1.5 text-xs text-background-200">{item.meta}</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}